import React from "react";
import { AddPodcastsToTheGroupLoaderTemplate } from "themes/administration/podcast/components";

function AddPodcastsToTheGroupLoader(props) {
    return <AddPodcastsToTheGroupLoaderTemplate {...props} />;
}

export default AddPodcastsToTheGroupLoader;
